// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ComponentLibraryBindings$PorterinFeature from "../../../containers/bindings/ComponentLibraryBindings.mjs";

function getCountryAndLanguageHeaders(country, language) {
  return {
          country: country,
          language: language
        };
}

function assignLocaleHeaders(current_headers) {
  var localeHeaders = ComponentLibraryBindings$PorterinFeature.LocaleHelper.getLocaleHeaders(undefined);
  return Object.assign(current_headers, localeHeaders);
}

export {
  getCountryAndLanguageHeaders ,
  assignLocaleHeaders ,
}
/* ComponentLibraryBindings-PorterinFeature Not a pure module */
